var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 49.875C33.6453 49.875 49.875 33.6453 49.875 13.625H57.125C57.125 33.6453 73.3548 49.875 93.375 49.875V57.125C73.3548 57.125 57.125 73.3548 57.125 93.375H49.875C49.875 73.3548 33.6453 57.125 13.625 57.125V49.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 12.75C7.15356 12.75 12.75 7.15356 12.75 0.25H15.25C15.25 7.15356 20.8465 12.75 27.75 12.75V15.25C20.8465 15.25 15.25 20.8465 15.25 27.75H12.75C12.75 20.8465 7.15356 15.25 0.25 15.25V12.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.f4d9aeb065b563c5b2a92b0bd21bd537.svg";
export { ForwardRef as ReactComponent };